import type { RouteObject } from 'react-router';
import { RequerPermissao } from '@/app/RequerPermissao';
import { paginaSobDemanda } from '@/app/pagina-sob-demanda';

/**
 * Rotas do MM Hays, sob `RequerPermissao` como **rota-mãe**.
 *
 * 🚨 Segunda tranca. A que vale é o `@Permissao()` de cada rota do backend: aqui só evitamos mostrar uma tela
 * que o servidor negaria. As chaves `mm_hays.*` são de concessão reservada ao master (ADR 0026): nenhum papel
 * nasce com elas, nem o `admin`.
 *
 * Iteração 13.4: as telas de conteúdo, sob `mm_hays.bases_ver` (ver é o portão; cada ação dentro da tela pede
 * a sua chave). Iteração 13.7: o chat, sob `mm_hays.conversar` — chave **diferente** da de conteúdo, porque
 * quem conversa não precisa poder mexer no que o MM Hays sabe.
 *
 * `/mm-hays/bases` é estática e vem declarada **antes** de `/mm-hays/conversas/:id` (o roteador ranqueia por
 * especificidade de qualquer forma; a ordem é para quem lê).
 */
export const rotas: RouteObject[] = [
  /*
   * Modelos de IA (iteração 13.15): a chave `mm_hays.configurar` é de concessão do master (ADR 0026) e,
   * além dela, o servidor exige SER o master — a rota só esconde o que a pessoa não pode abrir.
   */
  {
    element: <RequerPermissao permissao="mm_hays.configurar" />,
    children: [
      {
        path: '/mm-hays/modelos',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaModelosDeIa'),
          (m) => m.PaginaModelosDeIa,
          'Abrindo os modelos de IA…',
        ),
      },
    ],
  },
  {
    element: <RequerPermissao permissao="mm_hays.bases_ver" />,
    children: [
      {
        path: '/mm-hays/bases',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaBases'),
          (m) => m.PaginaBases,
          'Abrindo as bases do MM Hays…',
        ),
      },
      {
        path: '/mm-hays/bases/:id',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaBase'),
          (m) => m.PaginaBase,
          'Abrindo a base…',
        ),
      },
      {
        path: '/mm-hays/bases/:id/documentos/:docId',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaDocumento'),
          (m) => m.PaginaDocumento,
          'Abrindo o documento…',
        ),
      },
    ],
  },
  {
    element: <RequerPermissao permissao="mm_hays.conversar" />,
    children: [
      {
        path: '/mm-hays',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaMmHays'),
          (m) => m.PaginaMmHays,
          'Chamando o MM Hays…',
        ),
      },
      {
        path: '/mm-hays/conversas/:id',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaConversa'),
          (m) => m.PaginaConversa,
          'Chamando o MM Hays…',
        ),
      },
    ],
  },
];
